// ScoreTierLegend.js
import React from 'react';
import { Typography, Card } from 'antd';
import { isIpraService } from '../selfcare360/selfcare360Scales';

const { Text } = Typography;

const ScoreTierLegend = ({ redLight, yellowLight, serviceId }) => {
    const circleStyle = (color, size) => ({
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
    });

    if (isIpraService(serviceId)) {
        return (
            <Card bordered style={{ height: '100%' }}>
                <div style={{ display: 'flex', gap: 16 }}>
                    <div
                        style={{
                            backgroundColor: '#2f3640',
                            borderRadius: 30,
                            padding: '12px 0',
                            width: 60,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                        }}
                    >
                        <span style={circleStyle('#52c41a', 30)}></span>
                        <span style={circleStyle('#faad14', 30)}></span>
                        <span style={circleStyle('#fb8c00', 30)}></span>
                        <span style={circleStyle('#ff4d4f', 30)}></span>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Text strong style={{ fontSize: 13, color: '#52c41a' }}>85 - 100%</Text>
                            <Text style={{ fontSize: 13 }}>Riesgo bajo</Text>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Text strong style={{ fontSize: 13, color: '#faad14' }}>75 - 84%</Text>
                            <Text style={{ fontSize: 13 }}>Riesgo moderado</Text>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Text strong style={{ fontSize: 13, color: '#fb8c00' }}>65 - 74%</Text>
                            <Text style={{ fontSize: 13 }}>Riesgo alto</Text>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Text strong style={{ fontSize: 13, color: '#ff4d4f' }}>0 - 64%</Text>
                            <Text style={{ fontSize: 13 }}>Riesgo crítico</Text>
                        </div>
                    </div>
                </div>
            </Card>
        );
    }

    return (
        <Card bordered style={{ height: '100%' }}>
            <div style={{ display: 'flex', gap: 16 }}>
                <div
                    style={{
                        backgroundColor: '#2f3640',
                        borderRadius: 30,
                        padding: '12px 0',
                        width: 60,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                    }}
                >
                    <span style={circleStyle('#52c41a', 30)}></span>
                    <span style={circleStyle('#faad14', 30)}></span>
                    <span style={circleStyle('#ff4d4f', 30)}></span>
                </div>

                {/* Textos alineados al centro de cada círculo */}
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Text strong style={{ fontSize: 13, color: '#52c41a' }}>{parseFloat(yellowLight) + 0.1} - 100%</Text>
                        <Text style={{fontSize: 13}}>Alto ajuste a la cultura</Text>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Text strong style={{ fontSize: 13, color: '#faad14' }}>{parseFloat(redLight) + 0.1} - {parseFloat(yellowLight)}%</Text>
                        <Text style={{fontSize: 13}}>Mediano ajuste a la cultura</Text>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Text strong style={{ fontSize: 13, color: '#ff4d4f' }}>0 - {redLight}%</Text>
                        <Text style={{fontSize: 13}}>Bajo ajuste a la cultura</Text>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ScoreTierLegend;
